import React, {useState} from 'react';
import {animate, motion, useMotionValue} from 'framer-motion';
import SlotCounter from 'react-slot-counter';
import {JSX} from 'react';
import {AccessBtnComponent} from '../access-btn.component';
import {useNavigate} from 'react-router';

type Feature = {
    id?: string,
    title: string;
    description: JSX.Element;
    image: string;
    underImage?: JSX.Element;
    more?: string;
    colorClass?: string;
};

type TiltCardProps = {
    feature: Feature;
    index: number;
    showImage?: boolean;
};

const cardVariants = {
    hidden: {opacity: 0, y: 20},
    show: {opacity: 1, y: 0},
    hover: {},
};

const iconVariants = {
    hidden: {scale: 1},
    show: {scale: 1},
    hover: {
        scale: 1.15,
        transition: {type: 'spring', stiffness: 200},
    },
};

export function FullCard({feature, index, showImage}: TiltCardProps) {
    const rotateX = useMotionValue(0);
    const rotateY = useMotionValue(0);
    const [isHovered, setIsHovered] = useState(false);

    function handleMouseMove(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        const {left, top, width, height} = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;

        const centerX = width / 2;
        const centerY = height / 2;
        const multiplier = 7;

        const newRotateY = ((x - centerX) / centerX) * multiplier;
        const newRotateX = -((y - centerY) / centerY) * multiplier;

        rotateX.set(newRotateX);
        rotateY.set(newRotateY);
    }

    function handleMouseLeave() {
        animate(rotateX, 0, {duration: 0.3});
        animate(rotateY, 0, {duration: 0.3});
        setIsHovered(false);
    }

    function handleMouseEnter() {
        setIsHovered(true);
    }

    return (
        <motion.section
            className="w-full rounded-lg flex flex-col items-center text-center relative mt-10"
            variants={cardVariants}
            initial="hidden"
            whileInView="show"
            whileHover="hover"
            viewport={{once: true}}
            transition={{duration: 0.5, delay: index * 0.1}}

            onMouseMove={handleMouseMove}

        >
            <motion.div className="title" initial={'hidden'} animate={'show'}>
                <h1 className="lg:text-7xl text-4xl md:text-6xl sm:text-5xl font-bebasneue text-white">
                    {feature.title.length <= 10 ?(<SlotCounter
                        dummyCharacters={'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((char) => (
                            <span className="font-bebasneue text-gray-300">{char}</span>
                        ))}
                        duration={2}
                        value={feature.title.split('').map((char) => (
                            <span className="bg-gray-100 text-transparent bg-clip-text font-bebasneue">{char}</span>
                        ))}
                    />) : feature.title}
                </h1>
            </motion.div>

            {(feature.image || feature.description) && (<motion.div
                className={`w-full flex ${index % 2 === 0 ? 'md:flex-row flex-col' : 'md:flex-row-reverse flex-col'} md:flex-row flex-col-reverse justify-between`}
                onMouseLeave={handleMouseLeave}
                onMouseEnter={handleMouseEnter}
            >
                {/*<motion.div className={`mb-4 ${feature.colorClass}`} >*/}
                {/*    <motion.div*/}

                {/*        className="relative"*/}

                {/*        transition={{duration: 0.5, ease: 'easeInOut'}}*/}
                {/*        style={{perspective: 1000, transformStyle: 'preserve-3d'}}*/}
                {/*    >*/}
                {/*        {showImage && feature.image && (<motion.img*/}
                {/*            alt=""*/}

                {/*            src={feature.image}*/}
                {/*            className="md:h-[32rem] h-[23rem] w-full object-contain"*/}
                {/*        />)}*/}
                {/*        {!showImage && (<div className="lg:h-[15rem]"></div>)}*/}

                {/*        {feature.underImage && (<div className="text-center">*/}
                {/*            {feature.underImage}*/}
                {/*        </div>)}*/}
                {/*        {feature.more && (*/}
                {/*            <AccessBtnComponent*/}
                {/*                text={feature.more}*/}
                {/*                onClick={() => navigate(`/slot/${feature.id}`)}*/}
                {/*                className="px-24 py-8 border-2 border-pink-700 rounded-xl text-white relative mt-6 text-lg font-semibold"*/}
                {/*            />*/}

                {/*        )}*/}
                {/*    </motion.div>*/}
                {/*</motion.div>*/}

                {/*{feature.description}*/}


            </motion.div>)}
        </motion.section>
    );
}
